export const GLOBAL_STATE = 'IConference'

export const ICONFERENCE = 'ICONFERENCE' as const
export const ICONFERENCE_CREATE = 'ICONFERENCE_CREATE' as const
export const ICONFERENCE_ALL = 'ICONFERENCE_ALL' as const
export const ICONFERENCE_ALL_FILTER = 'ICONFERENCE_ALL_FILTER' as const
export const ICONFERENCE_ARTICLE_LIST = 'ICONFERENCE_ARTICLE_LIST' as const
export const ICONFERENCE_ARTICLE = 'ICONFERENCE_ARTICLE' as const
export const ICONFERENCE_ARTICLE_ALL = 'ICONFERENCE_ARTICLE_ALL' as const
export const ICONFERENCE_MAGAZINE_ARTICLE = 'ICONFERENCE_MAGAZINE_ARTICLE' as const
export const ICONFERENCE_ARTICLE_STEP = 'ICONFERENCE_ARTICLE_STEP' as const
export const ICONFERENCE_ARTICLE_PROOF = 'ICONFERENCE_ARTICLE_PROOF' as const
export const ICONFERENCE_CATEGORY_ALL = 'ICONFERENCE_CATEGORY_ALL' as const
